export const KeyBinds = {
  ENTER: 13,
};
